import { ProductInterface } from '~/modules/GraphQL/types';

export const productMatch = (
  productA/*: ProductInterface*/,
  productB/*: ProductInterface*/,
): boolean => {
  const equalSku = productA?.sku === productB?.sku;

  return equalSku;
};
